import { axiosObject } from "../config";

function newsletterSubscription(data: any) {
    return new Promise((resolve, reject) => {
        let uri = "auction/data/resource/newsletter-subscriptions/_create";
        axiosObject
            .post(uri, data)
            .then((response) => {
                resolve(response.data);
            })
            .catch((errors) => {
                reject(errors);
            });
    });
}


export { newsletterSubscription };
